import React from 'react'
import { useNavigate } from 'react-router-dom'
import './AccountNotFound.scss'

interface AccountNotFoundProps {
  email?: string
}

export const AccountNotFound: React.FC<AccountNotFoundProps> = ({ email }) => {
  const navigate = useNavigate()

  return (
    <div className='account-not-found-container bg-white rounded-4 ms-auto me-auto'>
      <div className='account-not-found-inner d-flex flex-column align-items-center gap-4'>
        <i className='bi bi-shield-lock account-not-found-icon' />
        <p className='account-not-found-title fw-bold text-center m-0'>Account not found</p>
        <div className='d-flex flex-column align-items-center gap-2 w-100'>
          {email ? (
            <>
              <p className='account-not-found-body fw-medium text-dark text-center m-0'>There&#39;s no Zocks account linked to</p>
              <p className='account-not-found-body fw-bold text-dark text-center m-0'>{email}.</p>
            </>
          ) : (
            <p className='account-not-found-body fw-medium text-dark text-center m-0'>There&#39;s no Zocks account linked to this identity.</p>
          )}
        </div>
        <div className='w-100 pb-3'>
          <p className='account-not-found-body fw-medium text-dark text-center m-0'>Create a new account, or go back and try a different login method.</p>
        </div>
        <div className='d-flex gap-3 w-100'>
          <button className='account-not-found-button' onClick={() => navigate('/')} type='button'>
            Back to log in
          </button>
          <button className='account-not-found-button' onClick={() => navigate('/signup')} type='button'>
            Create an account
          </button>
        </div>
        <div className='account-not-found-support text-center pt-3'>
          Need help? Please contact us at{' '}
          <a href='mailto:support@zocks.io' className='account-not-found-support-link'>
            support@zocks.io
          </a>
          .
        </div>
      </div>
    </div>
  )
}
